module.exports = __webpack_public_path__ + "img/icon_agent_es.fb06f9ec.png";